import React from "react";

export const CheckmarkCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 12C0 5.373 5.373 0 12 0a12 12 0 0112 12c0 6.627-5.373 12-12 12S0 18.627 0 12zm10.476 4.02l6.744-6.744a.6.6 0 000-.828l-.636-.636a.6.6 0 00-.84 0L10.056 13.5l-1.8-1.788a.576.576 0 00-.84 0l-.636.636a.6.6 0 000 .852l2.856 2.82a.576.576 0 00.84 0z"
      clipRule="evenodd"
    ></path>
  </svg>
);
